import api from '@common/components/address/service/address.service';
import * as types from '@common/components/address/store/address.actionType';
import addressActions from '@common/components/address/store/address.actions';

import { takeEvery, call, put } from 'redux-saga/effects';

export default workSaga;

function* workSaga() {
  yield takeEvery(types.ADDRESS_GET, getByCep);
  yield takeEvery(types.ADDRESS_GETCEPCIDADE, getByCepPorCidade);
}

function* getByCep(action) {
  const { payload } = action;

  const result = yield call(api.getByCep, payload);
  yield put(addressActions.setAddress(result.data));
}

function* getByCepPorCidade(action) {
  const { payload } = action;

  const result = yield call(api.getByCepPorCidade, payload);
  yield put(addressActions.setAddress(result.data));
}
